import React from 'react';
import { getServiceCardImage } from '../utils/mediaUrl';
import './ServiceCardImage.css';

const ServiceCardImage = ({ service, className = '', alt = '' }) => {
  const src = getServiceCardImage(service);
  const name = alt || service?.service_name || 'Service';

  if (src) {
    return (
      <div className={`service-card-image ${className}`.trim()}>
        <img src={src} alt={name} loading="lazy" />
      </div>
    );
  }

  return (
    <div className={`service-card-image service-card-image--placeholder ${className}`.trim()}>
      <span>{name.charAt(0)}</span>
    </div>
  );
};

export default ServiceCardImage;
